import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DeployedYear, DropdownMonthList, DropdownPaymentTypeOptions, EmptyString, FormTypeAdd, FormTypeEdit, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import { useModal } from "utils/context/ModalContext"
import { MainBodyCard } from "components/Cards/MainBodyCard"
import { PagesFormTitle } from "components/Cards/PagesFormTitle"
import { FormCard } from "components/Cards/FormCard"
import { PaymentService } from "services/PaymentService"
import { BookingService } from "services/BookingService"
import Select from "react-select"

export default function PaymentForm(){
    const navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchCreatePayment, fetchUpdatePayment, fetchDeletePayment, fetchPaymentById } = PaymentService()
    const { fetchBookingList } = BookingService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paymentId = queryString.get("paymentId")
    let paramBookingId = queryString.get("bookingId")

    const [paymentDate, setPaymentDate] = useState(new Date())
    const [paymentType, setPaymentType] = useState(EmptyString)
    const [bookingOptions, setBookingOptions] = useState([])
    const [tenantName, setTenantName] = useState(EmptyString)
    const [bookingId, setBookingId] = useState(EmptyString)
    const [paymentPeriodeMonth, setPaymentPeriodeMonth] = useState(moment(new Date()).format("M"))
    const [yearOptions, setYearOptions] = useState([])
    const [paymentPeriodeYear, setPaymentPeriodeYear] = useState(moment(new Date()).format("yyyy"))
    const [amount, setAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)

    // HEADER
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    // BUTTON
    const saveBtnClick = async () => {
        if (!validateForm()) return
        
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            if (formType === FormTypeAdd){
                await fetchCreatePayment(
                    moment(paymentDate).format(InsertDateFormat),
                    paymentType,
                    bookingId,
                    paymentPeriodeMonth,
                    paymentPeriodeYear,
                    amount.replaceAll(",", ""),
                    remark
                )
            }else{
                await fetchUpdatePayment(
                    paymentId,
                    moment(paymentDate).format(InsertDateFormat),
                    paymentType,
                    bookingId,
                    paymentPeriodeMonth,
                    paymentPeriodeYear,
                    amount.replaceAll(",", ""),
                    remark
                )
            }
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/payment')
                }
            })
        }
    }
    const deleteBtnClick = async () => { 
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeletePayment(paymentId, status)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/payment')
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        // if (tenantName === EmptyString){
        //     errorCount++
        //     setErrorTenantName(true)
        // }else{
        //     setErrorTenantName(false)
        // }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fGetYear(){
        let deployedYear = parseFloat(DeployedYear)
        let thisYear = parseFloat(moment(new Date()).format("yyyy"))
        let tempArray = []

        if (thisYear > deployedYear){
            for(let i = deployedYear; i < (thisYear + 3); i++){
                let tempArray = []
                tempArray.push({label: String(i), value: String(i)})                
            }
        }else{
            for(let i = deployedYear; i < (deployedYear + 3); i++){                
                tempArray.push({label: String(i), value: String(i)})
            }
        }

        setYearOptions(tempArray)
    }

    const getPaymentById = async () => {
        const res = await fetchPaymentById(paymentId)
        if (!res) return

        const data = res.data
                
        setPaymentDate(data.paymentDate)
        setPaymentType(data.paymentType)
        setBookingId(String(data.bookingId))
        setPaymentPeriodeMonth(data.paymentPeriodeMonth)
        setPaymentPeriodeYear(data.paymentPeriodeYear)
        setAmount(money(data.amount))
        setRemark(data.remark)
        setTenantName(data.tenantName.toUpperCase())

        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)
    }
    const getBookingList = async () => {
        const res = await fetchBookingList(
            '',
            '',
            '1',
            '',
            '1',
            1000,
            0
        )

        const data = res.data.listData
        const options = data.map((item) => ({ label: item.tenantName.toUpperCase() + ' - ' + item.roomNumber, value: String(item.bookingId) }))

        setBookingOptions(options)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                fGetYear()
                await getBookingList()

                if (formType ===  FormTypeEdit){
                    await getPaymentById()
                } else {
                    if (paramBookingId !== null && typeof(paramBookingId) !== 'undefined'){
                        setBookingId(paramBookingId)
                    }
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()        
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Payment Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Payment Date'>
                    <DatePicker className="w-full h-10 bg-white" value={paymentDate} onChange={(e) => { setPaymentDate(e) }} />
                </FormCard>

                <FormCard title='Payment Type'>
                    <Dropdown className="" options={DropdownPaymentTypeOptions} value={paymentType} onChange={(e) => { setPaymentType(e.value) }} placeholder="Select Payment Type" />
                </FormCard>

                <FormCard title='Tenant'>
                    <label className={`${formType === FormTypeEdit ? 'block' : 'hidden'}`}>{tenantName}</label>
                    <Select className={`${formType === FormTypeEdit ? 'hidden' : 'block'}`} options={bookingOptions} value={bookingOptions.find(x => x.value === bookingId)} onChange={(e) => setBookingId(e.value)} placeholder="Select Tenant" />                
                </FormCard>

                <FormCard title='Payment Periode'>
                    <div className="flex justify-between">
                        <Dropdown className="w-7/12" options={DropdownMonthList} value={paymentPeriodeMonth} onChange={(e) => { setPaymentPeriodeMonth(e.value) }} placeholder="Month" />
                        <Dropdown className="w-4/12" options={yearOptions} value={paymentPeriodeYear} onChange={(e) => { setPaymentPeriodeYear(e.value) }} placeholder="Year" />  
                    </div>                               
                </FormCard>
                
                <FormCard title='Amount'>
                    <div className="flex rounded-md w-full border border-app-light-grey">
                        <div className="py-2 px-4 border-r">
                            <span>Rp</span>
                        </div>
                        <input className="bg-white w-full px-4 py-2 text-right" type="" value={amount} onChange={(e) => { setAmount(money(e.target.value)) }} />
                    </div>                  
                </FormCard>
                
                <FormCard title='Remark'>
                    <input className="input" value={remark} onChange={(e) => { setRemark(e.target.value) }} />
                </FormCard>

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
        </MainBodyCard>
    )
}